import { useEffect } from "react";
import { DsdLoading } from "../DSD/DsdLoading";

function Loading() {
  useEffect(() => {
    //Force le focus sur le spinner lors du chargement initiale
    setTimeout(() => document.getElementById("element-loading-amc")?.focus(), 1000);

    return () => {
      //Focus sur le span chargement terminé lorsque enlève le spinner
      document.getElementById("chargement-termine-amc")?.setAttribute("aria-hidden", "false");
      document.getElementById("chargement-termine-amc")?.focus();
    };
  }, []);
  return <DsdLoading id="element-loading-amc" size={"md"} />;
}

export default Loading;
